import Shop from './Index.vue';

export const routes = [
  {
    path: 'loja',
    name: 'talkvia_shop',
    meta: {
      permissions: ['administrator'],
      superAdminOrAdmin: true,
    },
    component: Shop,
  },
];
